// Current live state
export const N550_ISAD_MOCK = {
  "N550-SEG-001": "A",
  "N550-SEG-002": "B",
  "N550-SEG-003": "C",
  "N550-SEG-004": "D",
  "N550-SEG-005": "E",
  "N550-SEG-006": "C",
  "N550-SEG-007": "B",
  "N550-SEG-008": "A",
  "N550-SEG-009": null,
  "N550-SEG-010": "D",
  "N550-SEG-011": "E",
  "N550-SEG-012": "C",
  "N550-SEG-013": "B",
  "N550-SEG-014": "D",
  "N550-SEG-015": "A",
};

export const N550_ISAD_HISTORICAL = {
  "N550-SEG-001": "B",
  "N550-SEG-002": "C",
  "N550-SEG-003": "D",
  "N550-SEG-004": "E",
  "N550-SEG-005": "E",
  "N550-SEG-006": "D",
  "N550-SEG-007": "C",
  "N550-SEG-008": "B",
  "N550-SEG-009": null,
  "N550-SEG-010": "E",
  "N550-SEG-011": "E",
  "N550-SEG-012": "D",
  "N550-SEG-013": "C",
  "N550-SEG-014": "E",
  "N550-SEG-015": "B",
};

export function getIsadForTimeRange(dateRange) {
  if (!dateRange) return N550_ISAD_MOCK;
  const [, end] = dateRange;
  const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 3_600_000);
  return end.toDate() >= sevenDaysAgo ? N550_ISAD_MOCK : N550_ISAD_HISTORICAL;
}
